import { AxiosError } from 'axios'

export function isAxiosError(err: any): err is AxiosError {
  if (!err) {
    return false
  }

  return Boolean(err.isAxiosError)
}
